import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "setting-component" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = {
  for: "once-twice-sold",
  class: "form-label"
}
const _hoisted_4 = { class: "form-group-fields" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  class: "form-label",
  for: "book-bid-key-label"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = {
  class: "form-label",
  for: "book-bid-first-key-label"
}
const _hoisted_9 = { class: "form-group-fields" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = {
  class: "form-label",
  for: "pass-lot-key-label"
}
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = {
  class: "form-label",
  for: "retract-lot-key-label"
}
const _hoisted_14 = { class: "action-block" }

import { useAuctionStore } from "@/stores/AuctionStore";
  import { ref, watch } from "vue";
  import { trans } from "@/utils/trans";
  import CustomHotKeyInput from "@/components/_partials/widget/CustomHotKeyInput.vue";
  import apiClient from "@/services/api";
  import { useToast } from "primevue/usetoast";
  import { HotKeyEnum } from "@/enum";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Hotkeys',
  setup(__props) {

  const toast = useToast();

  const auctionStore = useAuctionStore();

  const parseValues = (value: string[] | string | null | undefined) => {
    if (value) {
      if (typeof value === "string") {
        return JSON.parse(value);
      } else {
        return value;
      }
    }
    return [];
  };

  const hotkeysData = ref({
    once_twice_sold_hot_key: parseValues(auctionStore.liveSettings?.once_twice_sold_hot_key),
    pass_lot_hot_key: parseValues(auctionStore.liveSettings?.pass_lot_hot_key),
    book_bid_first_hot_key: parseValues(auctionStore.liveSettings?.book_bid_first_hot_key),
    book_bid_hot_key: parseValues(auctionStore.liveSettings?.book_bid_hot_key),
    retract_bid_hot_key: parseValues(auctionStore.liveSettings?.retract_bid_hot_key)
  });

  watch(
    () => auctionStore.liveSettings,
    (nv) => {
      hotkeysData.value.once_twice_sold_hot_key = parseValues(nv?.once_twice_sold_hot_key);
      hotkeysData.value.pass_lot_hot_key = parseValues(nv?.pass_lot_hot_key);
      hotkeysData.value.book_bid_first_hot_key = parseValues(nv?.book_bid_first_hot_key);
      hotkeysData.value.book_bid_hot_key = parseValues(nv?.book_bid_hot_key);
      hotkeysData.value.retract_bid_hot_key = parseValues(nv?.retract_bid_hot_key);
    },
    { deep: true }
  );

  const save = () => {
    const data = {
      once_twice_sold_hot_key: JSON.stringify(hotkeysData.value.once_twice_sold_hot_key),
      pass_lot_hot_key: JSON.stringify(hotkeysData.value.pass_lot_hot_key),
      book_bid_first_hot_key: JSON.stringify(hotkeysData.value.book_bid_first_hot_key),
      book_bid_hot_key: JSON.stringify(hotkeysData.value.book_bid_hot_key),
      retract_bid_hot_key: JSON.stringify(hotkeysData.value.retract_bid_hot_key)
    };

    apiClient.put(auctionStore.routes["auctions.update_live_settings"], data).then((response) => {
      if (response.data.status && response.data.settings) {
        auctionStore.$patch(response.data.settings);
      } else {
        console.log(response, response.data?.message);
      }
      toast.add({
        severity: response.data.status ? "success" : "error",
        summary: trans("live.toast." + (response.data.status ? "success" : "error")),
        detail: response.data.message || trans("live.toast.unknown_error"),
        life: 6000
      });
    });
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(trans)("live.tabs.settings.hotkeys_tab.labels.once_twice_sold_hot_key")), 1),
      _createVNode(CustomHotKeyInput, {
        modelValue: hotkeysData.value.once_twice_sold_hot_key,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((hotkeysData.value.once_twice_sold_hot_key) = $event)),
        "input-id": "once-twice-sold",
        type: "text",
        scope: "pass_lot_hot_key",
        "with-clear": "",
        "input-class": "input"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(trans)("live.tabs.settings.hotkeys_tab.labels.book_bid_hot_key")), 1),
        _createVNode(CustomHotKeyInput, {
          modelValue: hotkeysData.value.book_bid_hot_key,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((hotkeysData.value.book_bid_hot_key) = $event)),
          "input-id": "book-bid-key-label",
          type: "text",
          scope: "pass_lot_hot_key",
          "with-clear": "",
          "input-class": "input"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(trans)("live.tabs.settings.hotkeys_tab.labels.book_bid_first_hot_key")), 1),
        _createVNode(CustomHotKeyInput, {
          modelValue: hotkeysData.value.book_bid_first_hot_key,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((hotkeysData.value.book_bid_first_hot_key) = $event)),
          "input-id": "book-bid-first-key-label",
          type: "text",
          scope: "book_bid_first_hot_key",
          "with-clear": "",
          "input-class": "input"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(trans)("live.tabs.settings.hotkeys_tab.labels.pass_lot_hot_key")), 1),
        _createVNode(CustomHotKeyInput, {
          modelValue: hotkeysData.value.pass_lot_hot_key,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((hotkeysData.value.pass_lot_hot_key) = $event)),
          "input-id": "pass-lot-key-label",
          type: "text",
          scope: "book_bid_hot_key",
          "with-clear": "",
          "input-class": "input"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(trans)("live.tabs.settings.hotkeys_tab.labels.retract_bid_hot_key")), 1),
        _createVNode(CustomHotKeyInput, {
          modelValue: hotkeysData.value.retract_bid_hot_key,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((hotkeysData.value.retract_bid_hot_key) = $event)),
          "input-id": "retract-lot-key-label",
          type: "text",
          scope: "retract_bid_hot_key",
          "with-clear": "",
          "input-class": "input"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        class: "btn btn-blue action",
        onClick: save
      }, _toDisplayString(_unref(trans)("live.tabs.settings.hotkeys_tab.actions.save")), 1)
    ])
  ]))
}
}

})